/** 83000 → "1:23"; 3723000 → "1:02:03" */
export const formatDuration = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = String(total % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
};

/** Fecha → "hace 5 s", "hace 3 min", "hace 2 h", "hace 4 d" */
export const formatAgo = (date, now = Date.now()) => {
  const secs = Math.max(0, Math.round((now - new Date(date).getTime()) / 1000));
  if (secs < 60) return `hace ${secs} s`;
  const mins = Math.round(secs / 60);
  if (mins < 60) return `hace ${mins} min`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `hace ${hours} h`;
  return `hace ${Math.round(hours / 24)} d`;
};
